<template>
  <div>
    <el-form ref="form" class="exr-files-form" label-width="80px">
      <ExercisePreview :entity="entity"></ExercisePreview>
      <div v-if="entity.files" class="exr-files">
        <div v-for="file in entity.files" :key="file.id" class="exr-file-item">
          <ImageInput v-model="file.url" :desc.sync="file.desc" :desc-rows="4"></ImageInput>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import ExercisePreview from "@/components/exercise/ExercisePreview.vue";
import ImageInput from "@/components/ImageInput.vue";

export default {
  name: "ExerciseFileForm",
  components: {ImageInput, ExercisePreview},
  data() {
    return {
      entity: {},
    }
  },
  methods: {
    reset(item) {
      if (!item || !item.id) {
        this.entity = {};
        return;
      }
      this.$http.get(this.$urls.exercise_files_view, {
        params: {id: item.id}
      }).then(res => {
        this.entity = res.data || {};
      })
    },
    submit() {
      return this.$http.post(this.$urls.exercise_files_update, {
        fileDesc: this.entity.files
      })
    }
  }
}
</script>

<style scoped>
.exr-files {
  margin-top: 30px;
}
.exr-file-item {
  margin-top: 12px;
  height: 120px;
}
</style>